import React, { createContext, useContext, useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';
import { useAuth } from '@/lib/AuthContext';

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const loadFavorites = async () => {
    if (!user) {
      setFavorites([]);
      setLoaded(true);
      return;
    }
    try {
      const data = await base44.entities.Favorite.list();
      setFavorites(data);
    } catch {
      setFavorites([]);
    }
    setLoaded(true);
  };

  useEffect(() => {
    loadFavorites();
  }, [user?.id]);

  const isFavorite = (productId) => favorites.some(f => f.product_id === productId);

  const toggleFavorite = async (product) => {
    const existing = favorites.find(f => f.product_id === product.id);
    if (existing) {
      await base44.entities.Favorite.delete(existing.id);
      setFavorites(prev => prev.filter(f => f.product_id !== product.id));
    } else {
      const created = await base44.entities.Favorite.create({
        product_id: product.id,
        product_name: product.name,
        product_image: product.image_url,
        product_price: product.price,
      });
      setFavorites(prev => [...prev, created]);
    }
  };

  return (
    <FavoritesContext.Provider value={{ favorites, isFavorite, toggleFavorite, loaded }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);